/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowUpFromBracketIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M21.063 4.422 29 12.426c.625.625.625 1.563 0 2.126-.562.625-1.5.625-2.062 0L21.5 9.112v15.382c0 .876-.687 1.501-1.5 1.501-.875 0-1.5-.625-1.5-1.5l-.062-15.383L13 14.552c-.562.625-1.5.625-2.062 0-.626-.563-.626-1.5 0-2.126l8-8.004c.562-.563 1.5-.563 2.125 0M9 25.495v5.002C9 31.936 10.063 33 11.5 33h17c1.375 0 2.5-1.064 2.5-2.502v-5.002c0-.813.625-1.5 1.5-1.5.813 0 1.5.687 1.5 1.5v5.002C34 33.561 31.5 36 28.5 36h-17A5.47 5.47 0 0 1 6 30.497v-5.002c0-.813.625-1.5 1.5-1.5.813 0 1.5.687 1.5 1.5"/>}
        </IconWrapper>);
}
